import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { CirclePlus } from "lucide-react";

import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import CustomInput from "../../../components/UI/PageInput/CustomInput";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import { ADD_OPERATOR } from "../../../api/allApi_List";
import SiteOperatorDialog from "../dialog/SiteOperatorDialog";
import {
  noSpaceOnlyValidation,
  phoneValidation,
} from "../../../validations/formValidations";

const AddOperatorForm = ({ executePost, successResponse, loading }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();
  const { name, id } = useParams();

  const onSubmit = (data) => {
    const sendDta = {
      station_id: parseInt(id),
      ...data,
    };
    executePost(sendDta, ADD_OPERATOR, () => {});
  };
  const formDetails = watch();

  return (
    <>
      <form
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        className="add-operator-form"
      >
        <label htmlFor={name} className="readyOnlyLabel">
          Station Name
        </label>
        <p className="readyOnlyInput">{name}</p>
        <CustomInput
          type="text"
          name="name"
          labelText="Operator Name *"
          placeholder="Enter"
          register={{
            ...register("name", {
              ...noSpaceOnlyValidation,
              required: "Please Enter a name",
            }),
          }}
          error={errors.name}
        />
        <CustomInput
          type="text"
          name="mobile"
          labelText="Phone No. *"
          placeholder="Enter"
          register={{
            ...register("mobile", {
              ...phoneValidation,
              required: "Please Enter phone number",
            }),
          }}
          error={errors.mobile}
        />
        <div className="addBtn---wrap gap-2">
          <PrimaryButton
            btnText={!loading ? "Add Operator" : "Adding..."}
            loading={loading}
            Icon={CirclePlus}
            size={18}
          />
          <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
        </div>
      </form>
      {successResponse && (
        <SiteOperatorDialog
          viewDetails={formDetails}
          stationName={name}
          stationId={id}
        />
      )}
    </>
  );
};

export default AddOperatorForm;
